export const painPoints = [
  {
    title: 'Presupuestos "inflados"',
    text: 'Talleres que ven que no sabés nada y te cobran "mano de obra de lujo" por arreglos simples.',
  },
  {
    title: 'Repuestos truchos',
    text: 'Pagar por un original y recibir una imitación que se rompe a los dos meses.',
  },
  {
    title: 'Pánico en la ruta',
    text: 'Quedarse tirado con la familia y no saber si el auto recalienta por una manguera de $5.000 o una tapa de cilindro de $800.000.',
  },
  {
    title: 'Pérdida de valor',
    text: 'Tu capital se desvaloriza porque no sabés cómo mantenerlo impecable para una futura reventa.',
  },
]

export const skills = [
  {
    title: 'Auditoría de talleres',
    text: 'El protocolo para verificar arreglos y que no te cobren "fantasmas".',
  },
  {
    title: 'Diagnóstico por síntomas',
    text: 'Entendé ruidos, humos y vibraciones antes de que se conviertan en roturas graves.',
  },
  {
    title: 'Mantenimiento low-cost',
    text: 'Cambiá filtros, fluidos y luces vos mismo y ahorrate miles de pesos en mano de obra.',
  },
  {
    title: 'Escudo anti-funde',
    text: 'Identificá las 3 fallas críticas que destruyen un motor y cómo reaccionar en segundos.',
  },
]

export const valueStack = [
  {
    icon: '📘',
    label: 'Manual Maestro de Mecánica Inteligente',
    price: 18000,
    isMain: true,
  },
  {
    icon: '🎁',
    label: 'BONO 1: Checklist para revisar un auto usado (evitá clavos)',
    price: 7500,
    isMain: false,
  },
  {
    icon: '🎁',
    label: 'BONO 2: Guía de supervivencia ante emergencias en ruta',
    price: 5000,
    isMain: false,
  },
  {
    icon: '🎁',
    label: 'BONO 3: Guía de compra de repuestos (dónde y qué marca)',
    price: 4500,
    isMain: false,
  },
  {
    icon: '🎁',
    label: 'BONO 4: Guía legal anti-multas y documentación',
    price: 6000,
    isMain: false,
  },
  {
    icon: '🎁',
    label: 'BONO 5: Guía detailing para subir el valor de reventa',
    price: 5500,
    isMain: false,
  },
]

export const faqs = [
  {
    question: 'No sé nada de herramientas, ¿me sirve igual?',
    answer:
      'Totalmente. El manual está diseñado para que entiendas el auto. La mayoría de las tareas DIY requieren herramientas básicas que ya tenés en casa o que cuestan muy poco.',
  },
  {
    question: 'Mi auto es nuevo/viejo, ¿aplica?',
    answer:
      'Sí. Los principios de la mecánica y las estafas en los talleres no discriminan modelo. Cubrimos desde autos con carburador hasta inyección electrónica moderna.',
  },
  {
    question: '¿Es un libro físico o digital?',
    answer:
      'Es 100% digital (PDF de alta calidad). Lo recibís en tu email al instante y lo llevás siempre en el celular para consultarlo dentro del auto o frente al mecánico.',
  },
]

export const TOTAL_VALUE = 46500
export const PRICE = 19900
export const CHECKOUT_URL =
  'https://mecanica-inteligente.impultienda.ar/checkout'
